<template>
  <div
    class="calciatore-gallery"
    :class="'calciatore-gallery--ruolo-' + calciatore.ID_Ruolo"
  >
    <!-- <div class="calciatore-gallery-visual"> -->
      <!-- <div class="calciatore-sx"> -->
        <div class="calciatore-gallery-avatar-wrap">
          <div class="imgCalciatore without-ms">
            <div class="imgContainer imgContainer-ruolo_">
              <div
                class="img"
                :key="calciatore.nid"
                :style="{ backgroundImage: `url(${avatarUrl})` }"
              ></div>
            </div>
          </div>

          <div
            v-if="calciatore.ID_Club"
            class="calciatore-gallery-maglia-badge"
            aria-hidden="true"
          >
            <div
              class="calciatore-gallery-maglia"
              :style="{ backgroundImage: magliaClub }"
            ></div>
          </div>
        </div>
      <!-- </div> -->
    <!-- </div> -->

    <div class="calciatore-gallery-info">
      <div class="calciatore-gallery-name-row">
        <span
          class="Ruolo calciatore-gallery-role"
          :class="'Ruolo_' + calciatore.ID_Ruolo"
        >
          {{ ruolo(calciatore.ID_Ruolo) }}
        </span>
        <span class="calciatore-gallery-name font-hemi-head">
          {{ calciatore.calciatore }}
        </span>
      </div>

      <div class="calciatore-gallery-meta">
        <span v-if="mantra && calciatore.mantra_ids" class="d-flex">
          <span
            v-for="mantraId in calciatore.mantra_ids"
            :key="mantraId"
            class="ml-1"
            :class="'ruolo-mantra' + mantraId"
          >
            {{ ruoloMantra(mantraId) }}
          </span>
        </span>
        <span>{{ calciatore.nomeClub }}</span>
        <quotazione
          v-if="showQuotazione"
          :quotazione="calciatore.quotazione"
        ></quotazione>
      </div>
    </div>

  </div>
</template>

<script>
import Config from "../../../config-app/config";
import Constants from "../../js/constants";
import Quotazione from "./Quotazione";

export default {
  name: "calciatore-gallery",
  components: {
    Quotazione,
  },
  props: {
    calciatore: {
      type: Object,
      required: true,
    },
    mantra: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ruolo(ruoloId) {
      return Constants.RUOLI[ruoloId];
    },
    ruoloMantra(mantraId) {
      return Constants.RUOLI_MANTRA[mantraId]
        ? Constants.RUOLI_MANTRA[mantraId].label
        : "-";
    },
  },
  computed: {
    showQuotazione() {
      return (
        this.calciatore.quotazione !== undefined &&
        this.calciatore.quotazione !== null
      );
    },
    avatarUrl() {
      return this.calciatore.imgCalciatore
        ? this.calciatore.imgCalciatore
        : Config.PUBLIC_DIR +
            "/schede_calciatori/avatar/default/avatar_club_" +
            this.calciatore.ID_Club +
            ".png";
    },
    magliaClub() {
      if (!this.calciatore.ID_Club) return "";

      return `url(${Config.PUBLIC_DIR}/clubs/maglie/400x400/ID_Anno_${Config.ID_ANNO_MAGLIE}/img_scheda_club_${this.calciatore.ID_Club}.png)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.calciatore-gallery {
  --calciatore-gallery-role-color: var(--ruolo-1);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
  background: var(--v-navy-darken1);
  border-top: 3px solid var(--calciatore-gallery-role-color);
  border-radius: 6px;
  box-shadow: 0 5px 14px rgb(0 0 0 / 22%);
      align-items: center;
}

.calciatore-gallery--ruolo-2 {
  --calciatore-gallery-role-color: var(--ruolo-2);
}

.calciatore-gallery--ruolo-3 {
  --calciatore-gallery-role-color: var(--ruolo-3);
}

.calciatore-gallery--ruolo-4 {
  --calciatore-gallery-role-color: var(--ruolo-4);
}

// .calciatore-gallery-visual {
//   position: relative;
//   flex: 1 1 auto;
//   min-height: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   overflow: hidden;
//   background-color: rgb(255 255 255 / 5%);
// }

// .calciatore-gallery .calciatore-sx {
//     width: 100%;
//     aspect-ratio: 1;
//     max-width: 350px;
// }

.calciatore-gallery-avatar-wrap {
  position: relative;
  width: 100%;
  max-width: 520px;
  aspect-ratio: 3 / 2;
}

.calciatore-gallery .imgCalciatore {
  width: 100%;
  height: 100%;
}

.calciatore-gallery .imgCalciatore .imgContainer {
  // border-radius: 50%;
  overflow: hidden;
      background: none;
}

.calciatore-gallery .imgCalciatore .imgContainer .img {
  width: 55%;
  height: 100%;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
}

.calciatore-gallery-info {
  z-index: 1;
  width: 100%;
  padding: 10px 12px 12px;
}

.calciatore-gallery-name-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-width: 0;
      font-size: 35px;
}

.calciatore-gallery-role {
  flex: 0 0 auto;
  width: 22px;
  height: 22px;
  min-width: 22px;
  // font-size: 11px;
  font-weight: 700;
}

.calciatore-gallery-name {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  color: white;
  // font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calciatore-gallery-maglia-badge {
  position: absolute;
  // z-index: 2;
  right: 80px;
  bottom: -15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 108px;
  height: 108px;
  overflow: hidden;
  background: var(--v-navy-darken2);
  // border: 3px solid rgb(255 255 255 / 72%);
  border-radius: 50%;
  // box-shadow: 0 4px 12px rgb(0 0 0 / 32%);
}

.calciatore-gallery-maglia {
width: 108%;
    height: 100%;
    background-position: top 20px center;
    background-repeat: no-repeat;
    background-size: cover;
}

.calciatore-gallery-meta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  // min-height: 18px;
  // margin-top: 4px;
  overflow: hidden;
  color: rgb(255 255 255 / 66%);
  font-size: 15px;
  white-space: nowrap;
  text-align: center;
}

@media (max-width: 600px) {
  .calciatore-gallery-avatar-wrap {
    flex: 1 1 auto;
    width: auto;
    height: 100%;
    min-height: 0;
    max-width: 350px;
    max-height: 100%;
    aspect-ratio: 2 / 3;
  }
.calciatore-gallery-maglia-badge[data-v-a44546fa] {
    right: 0px;
}


  .calciatore-gallery .imgCalciatore .imgContainer .img {
    // background-size: cover;
              width: 120%;
        background-position: left -28px top 20px;
  }

  // .calciatore-gallery-visual {
  //   min-height: 0;
  // }

  .calciatore-gallery-info {
    flex: 0 0 auto;
    padding: 8px;
  }

  .calciatore-gallery-name {
    // font-size: 13px;
  }

  .calciatore-gallery-maglia-badge {
    // width: 8px;
    // height: 68px;
    // border-width: 2px;
  }
}
</style>
